<script>
  import { defineComponent } from 'vue'
  import { TabulatorFull as Tabulator } from 'tabulator-tables'
  import Card from '@/components/Card/Card.vue'
  import BarraPesquisa from '@/components/BarraPesquisa/BarraPesquisa.vue'
  import { colunaSelecionavel, linhasLoading } from './DataGridFuncsAux/dataGridFuncs'
  import Paginador from './components/Paginador/Paginador.vue'

  import Contador from './components/Contador/Contador.vue'
  import LoadingCell from './LitComponents/LoadingCell'
  import { headerClick } from './js/TabulatorEvents/headerClick'
  import { emitter, eventos } from '@/shared/emitter/emitter'
  import { propriedadesGrid } from '@/shared/services/tools'
  import http from '@/shared/axios-config/g-http-metodos'
  import files from '@/shared/files/files'
  const name = 'DataGrid'

  export default defineComponent({
    name,

    components: { Card, BarraPesquisa, Paginador, Contador },

    props: {
      colunas: {
        type: Array,
        default: () => [],
      },
      valores: {
        type: Array,
        default: () => [],
      },
      minWidth: {
        type: Number,
        default: 150,
      },
      placeholderPesquisa: {
        type: String,
        required: true,
      },
      exibeBarraPesquisa: {
        type: Boolean,
        default: true,
      },
      tamanhoPagina: {
        type: Number,
        default: 50
      },
      linhasSelecionaveis: {
        type: Boolean,
        default: false
      },
      colunasPesquisa: {
        type: Array,
        default: () => []
      },
      inverteBarraComBotoes: {
        type: Boolean,
        default: false,
      },
      barraSempreAberta: {
        type: Boolean,
        default: false,
      },
      mostraIconeFiltro: {
        type: Boolean,
        default: false
      },
      mostraIconeExcel: {
        type: Boolean,
        default: true
      },
      mostraIconeAtualizarLista: {
        type: Boolean,
        default: true
      },
      rota: {
        type: String,
        default: 'sem-rota'
      },
      paginacaoRemota: {
        type: Boolean,
        default: false,
      },
      posicaoBarraPesquisa: {
        type: String,
        default: 'flex-end'
      },
      verbose: {
        type: Boolean,
        default: false,
      },
      subcabecalho: {
        type: Boolean,
        default: false
      },
      buscaPorEmit: {
        type: Boolean,
        default: false
      },
      ...propriedadesGrid
    },

    emits: ['rowClick', 'rowDblClick', 'selectionRows', 'clickOrdenacao', 'atualiza'],

    mounted() {
      this.montaGrid();
      emitter.on(eventos.buscaCabecalho, (e) => {
        window.clearTimeout(this.timer);

        this.timer = setTimeout(() => {
          e.forEach((elemento) => {
            //procura nos campos se existe o "elemento"
            let filtro = this.parametros.Filtros.find(f => f.campo == elemento.campo);

            //se existe atualiza o valor
            if(filtro){
              filtro.valor = elemento.valor
            }
            else{
              //se não existe adiciona
              this.parametros.Filtros.push(elemento);
            }
          })

          this.resetPaginador++;
          if(this.buscaPorEmit)
            this.$emit(`buscaPorEmit`)
          else
            this.buscaDados();
        }, 1000);
      })
    },

    updated() {
      // this.buscaDados();
    },

    data() {
      return {
        tabulator: null,
        contador: 0,
        pesquisaEscrita: '',
        iconeExcel: files.retornaUrlImagem('Icone_Excel.svg'),
        iconeFiltro: files.retornaUrlImagem('Icon_Filtrar.svg'),
        iconeAtualizarLista: files.retornaUrlImagem('Icone_Atualizar_Lista.svg'),
        valoresInternos: this.paginacaoRemota ? linhasLoading(12, this.colunas) :  [],
        quantidadePorPagina: this.tamanhoPagina,
        paginaAtual: 1,
        ultimaPagina: 1,
        totalRegistros: 0,
        quantidadeAtual: 0,
        resetPaginador: 0,
        timer: null,
        tabulatorCarregado: false,
        ordenacaoAtual: {
          campo: '',
          ordenacoesAnteriores: []
        },
        cabecalhosOrdenados: []
      }
    },

    methods: {
      montaEventosGrid(){
        this.tabulator.on('dataSorting', (sorters) => {
          this.$emit('clickOrdenacao', sorters)
        });

        this.tabulator.on('headerClick', (e, coluna) => {
          headerClick(this, e, coluna);
        });
      },
      montaGrid() {

        this.tabulator = new Tabulator(this.$refs.table, {
          data: this.valoresInternos,
          reactiveData: true,
          debugInvalidOptions:false,
          layout: 'fitData',
          pagination: true,
          paginationSize: this.tamanhoPagina,
          height: '100%',
          paginationCounter: 'rows',
          columnDefaults: {
            minWidth: this.minWidth || 150,
          },
          langs: {
            default: {
              pagination: {
                counter: {
                  showing: 'Mostrando',
                  of: 'de',
                  rows: 'linhas',
                  pages: 'pág',
                },
              },
            },
          },
          footerElement: '#internal-footer',
          paginationCounterElement: '#contador-paginas',
          columns: this.montaColunas(),
        })


        this.tabulator.on("tableBuilt", () => {
          this.montaEventosGrid();
        });

        this.tabulator.on('cellClick', (_, cell) => {
          if(cell.getColumn()._column.definition.formatter == 'rowSelection') return;
          let dadosLinha = { ...cell.getRow().getData() }
          this.$emit('rowClick', dadosLinha)
        });

        this.tabulator.on('cellDblClick', (_, cell) => {
          if(cell.getColumn()._column.definition.formatter == 'rowSelection') return;
          let dadosLinha = { ...cell.getRow().getData() }
          this.$emit('rowDblClick', dadosLinha)
        });

        this.tabulator.on("rowSelectionChanged", (data) => {
          this.$emit('selectionRows', data)
        });


        this.tabulator.on("tableBuilt", () => {
          this.tabulatorCarregado = true;
        });

      },

      montaColunas(){
        let colunas = [...this.colunas]
        if(this.linhasSelecionaveis){
          colunas.unshift(colunaSelecionavel())
        }
        return colunas
      },

      pesquisa(e){
       this.parametros.PesquisaGeral = e
       this.resetPaginador++;
       this.resetPaginador++;
       if(this.buscaPorEmit)
        this.$emit(`buscaPorEmit`)
       else
        this.buscaDados();
      },

      montaFiltro(campo, valor, tipoPesquisa){
        return {
          field: campo,
          type: tipoPesquisa,
          value: valor
        }
      },

      trocaPagina(index){
        this.paginaAtual = index;
        this.buscaDados()
      },

      resetOrdenacao(){
        this.parametros.resetOrdenacao();
        this.ordenacaoAtual.ordenacoesAnteriores = []
      },

      buscaDados(){
        if(this.rota == 'sem-rota') return;
        if(!this.paginacaoRemota){
          http.get(`${this.rota}`)
          .requisicao
          .then(res => {
            if(this.verbose) {
              console.log(res)
            }

            this.valoresInternos = res.data.resultado.data
            this.setData();
          })
          return;
        }
        let _parametros = {...this.parametros}

        _parametros.Filtros = JSON.parse(JSON.stringify([...this.parametros.Filtros]))
        _parametros.Filtros = _parametros.Filtros.filter(x => !!x.valor || x.valor === 0); //removendo valores nulos ou indefinidos
        _parametros.Filtros.forEach(x => x.valor = `${x.valor}`) //convertendo todos os valores dos filtros para string
        _parametros.Paginacao.pagina = this.paginaAtual;
        _parametros.Paginacao.quantidade = this.quantidadePorPagina;

        if(this.tabulatorCarregado){
          let a = linhasLoading(12, this.colunas)
          this.tabulator.setData(a);
        }

        http.post(`${this.rota}`, _parametros)
        .requisicao
        .then(res => {
          if(this.verbose) {
            console.log(res)
          }
          console.log(res)
          this.valoresInternos = res.data.data.data
          this.ultimaPagina = res.data.data.pagesCount
          this.totalRegistros = res.data.data.count
          this.quantidadeAtual = this.valoresInternos.length
          console.log('valores internos', this.valoresInternos)
          this.setData();
        })
        .catch(err => {
          console.log(err)
          this.setData([]);
        })
      },

      setData(){
        this.tabulator.clearData();
        this.tabulator.addData(this.valoresInternos);
      },

    },

    computed: {
      colunasLoading(){
        let colunasLoading = this.colunas.map(x => {
          x.formatter = () => new LoadingCell()
          return x;
        })
        return colunasLoading
      }
    },

    watch: {
      valores(){
        if(!this.paginacaoRemota){
          this.valoresInternos = this.valores
          this.setData()
        }
      },
      busca(){
        this.buscaDados();
      }
    }
  })
</script>

<template>
  <Card class="container-datagrid">
    <div class="toolbar">
      <div class="toobar-icones">
        <slot name="preCabecalho"></slot>
        <BarraPesquisa
          :class="{
            'barrra-pesquisa-grid-ultimo': inverteBarraComBotoes
          }"
          v-if="exibeBarraPesquisa"
          v-model="pesquisaEscrita"
          :placeholder="placeholderPesquisa"
          :sempre-aberto="barraSempreAberta"
          @pesquisa="pesquisa"
        />
        <div class="outros-botoes-grid">
          <img v-if="mostraIconeFiltro" src="@/assets/imgs/Icon_Filtrar.svg">
          <img v-if="mostraIconeExcel" src="@/assets/imgs/Icone_Excel.svg" @click="tabulator.download('xlsx', 'data.xlsx', {compress:false})" />
          <img v-if="mostraIconeAtualizarLista" src="@/assets/imgs/Icone_Atualizar_Lista.svg" @click="$emit('atualiza')" />
        </div>
        <slot name="posCabecalho"></slot>
      </div>

      <div class="subcabecalho" v-if="subcabecalho">
        <slot name="embaixoCabecalho"></slot>
      </div>
    </div>

    <div class="container-tabulator">
      <div id="custom-grid" class="tabulator" ref="table"></div>
    </div>

    <div
      id="footer-datagrid"
      class="footer"
    >
      <div id="paginacao-remota" class="footer-paginacao" :class="{'display-none': !paginacaoRemota}">
        <Contador :quantidade-pagina="quantidadeAtual" :total-registros="totalRegistros"></Contador>
        <Paginador class="paginator"  :reset="resetPaginador" :totalPaginas="ultimaPagina" @nova-pagina="trocaPagina"/>
      </div>

      <div class="paginacao-local" :class="{'display-none': paginacaoRemota}">
        <div ref="contadorPaginas" id="contador-paginas"></div>
        <div ref="footer" class="controles-paginas">
          <div class="botao-controle">
            <img class="icone-angulos" src="@/assets/imgs/angles-left-solid.svg" />
          </div>
          <div class="botao-controle">
            <img class="icone-angulo" src="@/assets/imgs/angle-left-solid.svg" />
          </div>

          <div ref="internalFooter" id="internal-footer"></div>

          <div class="botao-controle">
            <img
              class="icone-angulo-t2"
              src="@/assets/imgs/angle-left-solid.svg"
            />
          </div>
          <div class="botao-controle">
            <img
              class="icone-anguls-t2"
              src="@/assets/imgs/angles-left-solid.svg"
            />
          </div>
        </div>
      </div>

    </div>
  </Card>
</template>

<style>
  .template-grid {
    grid-template-rows: repeat(v-bind('subcabecalho ? "2" : "1"'), auto);
  }

  .invisivel{
    display: none;
  }

  .toolbar {
    height: 100%;
    display: grid;
  }

  .container-datagrid {
    height: 100%;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 8fr 1fr;
  }

  .container-datagrid > * {
    padding: 0px 32px;
  }

  .container-tabulator {
    height: 100%;
    overflow: scroll;
    /* -ms-overflow-style: none; */
    /* scrollbar-width: none; */
  }

  .tabulator {
    margin: auto 1.5rem;
  }

  .icone-angulos, .icone-angulos-t2 {
    width: 12px;
  }
  .icone-angulo, .icone-angulo-t2 {
    width: 7px;
  }

  .icone-angulos-t2, .icone-angulo-t2 {
    --tw-rotate: 180deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .subcabecalho {
    margin-bottom: 1rem;
    overflow-x: auto;
  }

  .paginacao-local {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px 0;
  }

  .container-tabulator::-webkit-scrollbar {
    display: none;
  }

  /* .container-tabulator {
    position: relative;
  } */

  .container-tabulator .tabulator {
    background-color: white;
    border-radius: 12px;
    border-color: #e2e2e2;
    color: #626262;
    font-size: 15px;
    /* position: absolute; */
  }

  .container-datagrid .tabulator .tabulator-header {
    border-color: #e2e2e2;
  }

  .container-datagrid .tabulator .tabulator-row {
    border-bottom: 1px solid #f1f1f1;
  }

  .container-datagrid .tabulator-row {
    /* min-height: 20px; */
    height: 50px;
  }

  .container-datagrid .tabulator-row .tabulator-cell {
    /*celulas */
    border-right: none;
    /* min-height: 20px; */
    padding: 1rem 0rem;
    padding-left: 10px;
    /* padding-left: 10px; */
  }

  .container-datagrid
    .tabulator
    .tabulator-header
    .tabulator-frozen.tabulator-frozen-right,
  .container-datagrid
    .tabulator-row
    .tabulator-cell.tabulator-frozen.tabulator-frozen-right {
    border: 1px solid #efefef;
    padding: 1rem 0rem;
  }

  .container-datagrid .tabulator .tabulator-row-odd {
    background-color: #f7f7f7;
  }

  .container-tabulator .tabulator {
    border-color: #f1f1f1;
  }

  .container-datagrid .tabulator .tabulator-header .tabulator-col {
    background: white;
    color: #4f4c4d;
    border-right: none;
    /* height: 170px; */
    /* padding-left: 10px; */
  }

  .container-datagrid  .tabulator .tabulator-header .tabulator-col .tabulator-col-content{
    padding: 0px;
  }

  /* .container-datagrid .tabulator .tabulator-tableholder::-webkit-scrollbar {
    display: none;
  } */

  .container-datagrid
    .tabulator
    .tabulator-header
    .tabulator-col
    .tabulator-col-content
    .tabulator-col-sorter {
    display: none;
  }

  .controles-paginas {
    display: flex;
    gap: 0.5rem;
  }

  .container-datagrid .tabulator .tabulator-col-title {
    padding: 0;
    --padding-vertical: 10px;
    padding-top: var(--padding-vertical);
    padding-bottom: var(--padding-vertical);
    padding-left: 10px;
    font-family: "MontSerrat";
    color: #3e3e3e;
  }

  .container-datagrid .tabulator .tabulator-col-title:hover{
    background-color: #e2dfdf;
  }

  .container-datagrid
    .tabulator
    .tabulator-header
    .tabulator-col
    .tabulator-col-content {
    flex: 1;
  }

  .toobar-icones {
    cursor: pointer;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: v-bind('posicaoBarraPesquisa');
    gap: 1.25rem;
    padding: 2rem 2rem 1.5rem;
  }

  .outros-botoes-grid {
    display: flex;
    column-gap: 20px;
  }

  .asc .icone_asc{
    filter: brightness(0) saturate(100%) invert(28%) sepia(81%) saturate(1469%)
      hue-rotate(182deg) brightness(94%) contrast(101%);
  }

  .desc .icone_desc{
    filter: brightness(0) saturate(100%) invert(28%) sepia(81%) saturate(1469%)
      hue-rotate(182deg) brightness(94%) contrast(101%);
  }

  .ordenacao-ativo {
    filter: brightness(0) saturate(100%) invert(28%) sepia(81%) saturate(1469%)
      hue-rotate(182deg) brightness(94%) contrast(101%);
  }

  .container-datagrid [data-page='first'],
  .container-datagrid [data-page='prev'],
  .container-datagrid [data-page='next'],
  .container-datagrid [data-page='last'] {
    display: none;
  }

  .container-datagrid #footer-datagrid {
    color: #999898;
  }

  .container-datagrid
    #footer-datagrid
    .tabulator-page-counter
    span:nth-child(4) {
    font-weight: bold;
  }

  #footer-datagrid {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  #internal-footer .tabulator-pages {
    display: flex;
    gap: 8px;
  }

  #internal-footer .tabulator-pages .tabulator-page,
  .botao-controle {
    border: 1px solid #e6e4e4;
    width: 35px;
    height: 40px;
    border-radius: 7px;
    cursor: pointer;
  }

  .botao-controle {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #internal-footer .tabulator-pages .tabulator-page.active {
    border-color: #006cb7;
    color: #006cb7;
  }

  .botao-controle:active {
    border-color: #006cb7;
    filter: brightness(0) saturate(100%) invert(29%) sepia(25%) saturate(5528%)
      hue-rotate(184deg) brightness(92%) contrast(105%);
  }

  .container-datagrid .tabulator .tabulator-row-odd {
    background-color: white;
  }

  .container-datagrid .tabulator .tabulator-row-even {
    background-color: #F9F9F9;
  }

  .container-datagrid .tabulator .tabulator-row-even:hover,
  .container-datagrid .tabulator .tabulator-row-odd:hover {
    background-color: #e2dfdf;
  }

  .container-datagrid .tabulator .tabulator-headers {
    height: calc(auto - 2px) !important;
  }

  .container-datagrid .tabulator .tabulator-header .tabulator-col.tabulator-sortable.tabulator-col-sorter-element:hover{
    background-color: white;
  }

  .container-datagrid .tabulator .tabulator-col-title{
    display: flex;
    /* justify-content: center; */
  }

  .container-datagrid .tabulator .tabulator-col-title input{
    margin: auto;
  }

  .invisivel{
    visibility: hidden;
  }

  .barrra-pesquisa-grid-ultimo{
    order: 100;
  }

  .display-none{
    display: none;
  }


  .input-text-busca-cabecalho{
    border: transparent;
    outline: none;
  }

  .input-text-busca-cabecalho:active,
  .input-text-busca-cabecalho:focus{
    border-bottom: 1px solid #9f9f9f;
  }

  .paginator {
    margin-left: auto;
  }

  .footer {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .footer-paginacao {
    width: 100%;
    display: flex;
    padding-top: 1.2rem;
    margin: auto 2rem;
  }

   /* ===== Scrollbar CSS ===== */
  /* Firefox */
  .container-datagrid{
    --scrollbar-cor: #d1d1d1;
    --scrollbar-background: transparent;
    --scrollbar-tamanho: 8px;
  }

  .container-datagrid * {
    scrollbar-width: thin;
    scrollbar-color: var(--scrollbar-cor) var(--scrollbar-background);
  }

  /* Chrome, Edge, and Safari */
  .container-datagrid *::-webkit-scrollbar {
    width: var(--scrollbar-tamanho);
    height: var(--scrollbar-tamanho);
  }

  .container-datagrid *::-webkit-scrollbar-track {
    background: var(--scrollbar-background);
  }

  .container-datagrid *::-webkit-scrollbar-thumb {
    background-color: var(--scrollbar-cor);
    border-radius: 7px;
    border: 3px solid var(--scrollbar-background);
  }

  /* .tabulator-row.tabulator-selectable:hover{
  background-color: #008ff50e;
} */
</style>
